import uniqueId from '@form-create/utils/lib/unique';
import { makeOptionsRule } from '../../utils/index';
import { makeRequiredRule } from '../../utils';
var label = '单选框';
var name = 'radio';
export default {
  icon: 'iconfont icondanxuan1',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {},
      options: [{
        value: '选项1',
        label: '选项1'
      }, {
        value: '选项2',
        label: '选项2'
      }]
    };
  },
  props: function props() {
    return [makeOptionsRule('options'), makeRequiredRule()];
  },
  basic: function basic() {}
};